export enum AutopilotTrajectoryTypeEnum {
    Unknown,
    Mission,
    Delivery,
    Contingency,
    Terminate
}

export enum AutopilotTrajectoryDetailEnum {
    Unknown,
    Preliminary,
    ManualDetail,
    AutoDetail,
    Final
}

export enum AutopilotTrajectoryStatusEnum {
    Unknown,
    Initial,
    Execution,
    Updated,
    Contingency
}